import { ReportSyncState } from './enums/report-sync-state';
import {
  HarvestActivityReport,
  HarvestActivityReportStatus,
  HarvestActivityReportSyncState
} from './local-db/objects/harvest-activity-report';

export class AppConsts {
  static readonly EnterKey = 'Enter';
  static readonly Zero = 0;
  static readonly OneHundred = 100;
  static readonly EmptyString = '';
  static readonly FocusType = 0;
  static readonly exampleText1 = 'Ejemplo 1.';
  static readonly exampleText2 = 'Ejemplo 2.';
  static readonly InitialSynchronizationReportTriesCount = 0;
  static readonly IsSynchronized = true;
  static readonly IsApproved = true;

  static readonly HyphenDateFormat = 'dd-MM-yyyy';
  static readonly DefaultDateFormat = 'dd/MM/yyyy';
  static readonly DefaultDateTimeFormat = 'dd/MM/yyyy HH:mm';
  static readonly DefaultTimeFormat = 'HH:mm';

  static readonly harvestActivityReportsData: HarvestActivityReport[] = [
    {
      id: 2022140,
      number: '20250000004221',
      date: new Date(2025, 4, 7),
      status: HarvestActivityReportStatus.Pending,
      machineId: 5,
      teamId: 156,
      shiftId: 1,
      machineStartHourMeter: 1.31,
      machineEndHourMeter: 3.81,
      operatorName: 'Vero Gamarra',
      totalProductiveHours: 4.26,
      totalUnproductiveHours: 1.26,
      totalMaintenanceHours: 0,
      productiveActivities: [
        {
          standName: '23HA',
          length: 12,
          treeCount: 0,
          loadCount: 15,
          productiveHours: [
            {
              totalHours: 1.26,
              observations: '',
              productivityName: '5.0 - Extras Traslado Personal',
              hourTypeName: 'Horas Extras',
              productivityTypeCode: 'HE',
              startTime: new Date('2025-04-26T08:00:00'),
              endTime: new Date('2025-04-26T09:15:00'),
              localName: '',
            },
          ],
        },
        {
          standName: '23HA',
          length: 5,
          treeCount: 0,
          loadCount: 6,
          productiveHours: [
            {
              totalHours: 3,
              observations: '',
              productivityName: '5.0 - Extras Traslado Personal',
              hourTypeName: 'Horas Comunes',
              productivityTypeCode: 'HC',
              startTime: new Date('2025-04-26T16:00:00'),
              endTime: new Date('2025-04-26T19:00:00'),
              localName: '',
            },
          ],
        },
      ],
      unproductiveHours: [
        {
          totalHours: 1.26,
          observations: '',
          productivityName: '5.0 - Traslado Urgente',
          hourTypeName: 'Horas Extras',
          productivityTypeCode: 'HE',
          startTime: new Date('2025-04-26T08:00:00'),
          endTime: new Date('2025-04-26T09:15:00'),
          localName: '',
        },
      ],
      isAuthorizable: true,
      approvalRestrictionMessage: '',
    },
    {
      id: 2022141,
      number: '202500000042214547',
      date: new Date(2025, 4, 7),
      status: HarvestActivityReportStatus.Approved,
      machineId: 5,
      teamId: 156,
      shiftId: 1,
      machineStartHourMeter: 1.31,
      machineEndHourMeter: 3.81,
      operatorName: 'Vero Gamarra',
      totalProductiveHours: 4.26,
      totalUnproductiveHours: 1.26,
      totalMaintenanceHours: 0,
      productiveActivities: [
        {
          standName: '23HA',
          length: 12,
          treeCount: 0,
          loadCount: 15,
          productiveHours: [
            {
              totalHours: 1.26,
              observations: '',
              productivityName: '5.0 - Extras Traslado Personal',
              hourTypeName: 'Horas Extras',
              productivityTypeCode: 'HE',
              startTime: new Date('2025-04-26T08:00:00'),
              endTime: new Date('2025-04-26T09:15:00'),
              localName: '',
            },
          ],
        },
        {
          standName: '23HA',
          length: 5,
          treeCount: 0,
          loadCount: 6,
          productiveHours: [
            {
              totalHours: 3,
              observations: '',
              productivityName: '5.0 - Extras Traslado Personal',
              hourTypeName: 'Horas Comunes',
              productivityTypeCode: 'HC',
              startTime: new Date('2025-04-26T16:00:00'),
              endTime: new Date('2025-04-26T19:00:00'),
              localName: '',
            },
          ],
        },
      ],
      unproductiveHours: [
        {
          totalHours: 1.26,
          observations: '',
          productivityName: '5.0 - Traslado Urgente',
          hourTypeName: 'Horas Extras',
          productivityTypeCode: 'HE',
          startTime: new Date('2025-04-26T08:00:00'),
          endTime: new Date('2025-04-26T09:15:00'),
          localName: '',
        },
      ],
      isAuthorizable: true,
      approvalRestrictionMessage: '',
    },
    {
      id: 2022142,
      number: '202500000042214548',
      date: new Date(2025, 4, 7),
      status: HarvestActivityReportStatus.Rejected,
      machineId: null,
      teamId: 156,
      shiftId: 1,
      machineStartHourMeter: 0,
      machineEndHourMeter: 0,
      operatorName: 'Vero Gamarra',
      totalProductiveHours: 4.26,
      totalUnproductiveHours: 1.26,
      totalMaintenanceHours: 0,
      productiveActivities: [
        {
          standName: '23HA',
          length: 12,
          treeCount: 14,
          loadCount: 0,
          productiveHours: [
            {
              totalHours: 1.26,
              observations: '',
              productivityName: '5.0 - Extras Traslado Personal',
              hourTypeName: 'Horas Extras',
              productivityTypeCode: 'HE',
              startTime: new Date('2025-04-26T08:00:00'),
              endTime: new Date('2025-04-26T09:15:00'),
              localName: '',
            },
          ],
        },
        {
          standName: '23HA',
          length: 5,
          treeCount: 10,
          loadCount: 0,
          productiveHours: [
            {
              totalHours: 3,
              observations: '',
              productivityName: '5.0 - Extras Traslado Personal',
              hourTypeName: 'Horas Comunes',
              productivityTypeCode: 'HC',
              startTime: new Date('2025-04-26T16:00:00'),
              endTime: new Date('2025-04-26T19:00:00'),
              localName: '',
            },
          ],
        },
      ],
      unproductiveHours: [
        {
          totalHours: 1.26,
          observations: '',
          productivityName: '5.0 - Traslado Urgente',
          hourTypeName: 'Horas Extras',
          productivityTypeCode: 'HE',
          startTime: new Date('2025-04-26T08:00:00'),
          endTime: new Date('2025-04-26T09:15:00'),
          localName: '',
        },
      ],
      isAuthorizable: true,
      approvalRestrictionMessage: '',
    },
  ];
  
  static readonly harvestActivityReportsStatusData: HarvestActivityReportSyncState[] = [
    {
      harvestActivityReportId: 2022140,
      numberOfTries: 1,
      lastSync: new Date('2025-03-26T09:15:00'),
      state: ReportSyncState.Ok,
      isSynchronized: true,
      message: '',
      comment: '',
      isApproved: true,
      authorizedBy: 'admin',
    },
    {
      harvestActivityReportId: 2022141,
      numberOfTries: 3,
      lastSync: new Date('2025-05-26T09:15:00'),
      state: ReportSyncState.Error,
      isSynchronized: true,
      message: 'Server error',
      comment: 'Parte incorrecto para aprobar',
      isApproved: false,
      authorizedBy: 'admin',
    },
    {
      harvestActivityReportId: 2022142,
      numberOfTries: 2,
      lastSync: new Date('2025-04-26T09:15:00'),
      state: ReportSyncState.Ok,
      isSynchronized: true,
      message: '',
      comment: '',
      isApproved: true,
      authorizedBy: 'admin',
    },
  ];
}

export class SyncConsts {
  public static readonly PageSize = 100;
  public static readonly MaxRetries = 3;
  public static readonly RetryDelay = 1000;
  static readonly SyncIntervalMs = 60000;
}

export class LocalStorageConsts {
  public static readonly CurrentUserKey = 'currentUser';
  public static readonly AccessTokenKey = 'access_token';
  public static readonly RefreshTokenKey = 'refresh_token';
  public static readonly HealthCheckKey = 'last_healthcheck';
  public static readonly HealthCheckInterval = 30 * 1000;
}
